import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import LoginComponent from './LoginComponent';
import { actions } from './authReducer';

const LoginContainer = ({ isAuthenticated, isLoading, errors, clearErrors }) => {
  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <LoginComponent
      isLoading={isLoading}
      error={errors?.general?.[0]}
      onClearErrors={clearErrors}
    />
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.guardian.auth.isAuthenticated,
  isLoading: state.guardian.auth.isLoading,
  errors: state.guardian.auth.errors,
});

const mapDispatchToProps = (dispatch) => ({
  clearErrors: () => dispatch(actions.clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
